export enum AddressType {
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
}

export enum AddressSubType {
  LOCAL = 'LOCAL',
  FOREIGN = 'FOREIGN',
}

export type AddressSubTypeLowercase = Lowercase<AddressSubType>;
